import { Card, Checkbox, Radio, Typography, withStyles } from '@material-ui/core';
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import clsx from 'clsx';
import dayjs from "dayjs";
import JoditEditor from "jodit-react";
import _ from 'lodash';
import MobileDetect from 'mobile-detect';
import React from 'react';

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    addButton: {
        position: 'absolute',
        right: 20,
        bottom: 60,
        zIndex: 99,
        color: theme.palette.text.primary,
    },
    toolbarItem: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: "4px 4px 0 0"
    }
});

class Destinatarios extends XAPPComponent {

    handleChangeLocal = (_ALocal) => {
        const { data, handleChange } = this.props;
        let AArray = [...data.locais];
        if (!_.isUndefined(_.find(data.locais, { slug: _ALocal.slug }))) {
            let index = _.findIndex(data.locais, { slug: _ALocal.slug });
            AArray.splice(index, 1);
        }
        else {
            AArray.push({ "idlocal": _ALocal.idlocal, "idpessoa": _ALocal.idpessoa, "slug": _ALocal.slug });
        }
        handleChange({ "target": { "name": "locais", "value": AArray } });
    }

    handleChangeAllLocais = (_AGrupo = "") => {
        const { destinatarios, handleChange } = this.props;
        let AArray = [];
        if (_AGrupo === "todos") {
            if (!_.isNull(destinatarios)) {
                destinatarios.forEach(local => {
                    AArray.push({ "idlocal": local.idlocal, "idpessoa": local.idpessoa, "slug": local.slug });
                })
            }
        }
        handleChange({ "target": { "name": "locais", "value": AArray } });
    }

    isSelected = (_ALocal) => {
        const { data, destinatarios } = this.props;
        if (_ALocal === "todos") {
            return (data.locais.length === destinatarios.length);
        }
        return (!_.isUndefined(_.find(data.locais, { slug: _ALocal.slug })));
    }

    render() {
        const { theme, classes, destinatarios, data } = this.props;
        const form = this.state;

        return (
            <React.Fragment>
                {!_.isNull(destinatarios) && destinatarios.length > 0 &&
                    <Card
                        className={clsx("flex w-full mb-16 rounded-4 relative")}
                        id={"card_Todos"}
                    >
                        <Checkbox
                            name="selected"
                            checked={this.isSelected("todos")}
                            onClick={ev => ev.stopPropagation()}
                            onChange={ev => this.handleChangeAllLocais(this.isSelected("todos") ? "todos" : "")}
                        />
                        <div className="p-12 w-full flex flex-col sm:flex-row">
                            <Typography className="font-600 mb-6 w-320 items-center">{"Todos"}</Typography>
                        </div>
                    </Card>
                }
                {!_.isNull(destinatarios) && destinatarios.map(local => (
                    <Card
                        className={clsx("flex w-full mb-16 rounded-4 relative")}
                        id={"card_" + local.idlocal}
                    >
                        <Checkbox
                            name="selected"
                            checked={this.isSelected(local)}
                            onClick={ev => ev.stopPropagation()}
                            onChange={ev => this.handleChangeLocal(local)}
                        />
                        <div className="p-12 w-full flex flex-col sm:flex-row">
                            <Typography className="font-600 mb-6 w-320 items-center">{local.nome}</Typography>
                        </div>
                    </Card>
                ))}
            </React.Fragment>
        );
    }
}


export default withStyles(styles, { withTheme: true })(Destinatarios);
